import React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './_components/columns';
import { jdsTableStyles } from '../../components/jds/tableStyles';
import { JdsTableSkeleton } from '../../components/jds/JdsSkeleton';
import { JdsPagination } from '../../components/jds/JdsPagination';
import '../../components/jds/jds.css';
import { Actions } from './_components/actions';
import { useOffersBootstrap } from './offers.bootstrap.hook';

export function OffersJussub() {
  const {
    data,
    loading,
    totalRows,
    perPage,
    filterText,
    resetPaginationToggle,
    initialParams,
    handlePageChange,
    handlePerRowsChange,
    handleAddOfferButton,
    handleRowClicked,
    handleFilterChange,
    handleClearFilter,
  } = useOffersBootstrap();

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Ofertas</h1>
      <p className="text-muted mb-10">Listagem de ofertas do JusSub</p>

      <div className="jds-card jds-card--flush">
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <DataTable
            columns={columns}
            data={data}
            onRowClicked={handleRowClicked}
            highlightOnHover
            pointerOnHover
            customStyles={jdsTableStyles}
            progressPending={loading}
            progressComponent={<JdsTableSkeleton />}
            pagination
            perPage={perPage}
            paginationServer
            paginationDefaultPage={initialParams.page}
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <Actions
                filterText={filterText}
                onFilter={handleFilterChange}
                onClear={handleClearFilter}
                onAddClick={handleAddOfferButton}
              />
            }
            paginationComponent={JdsPagination}
            responsive={false}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
}
